export const state = {
  truckattendances: [],
  systemTruckattendance: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckattendances/state.js